var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu001"},[_c('ul',{staticClass:"first-tab dib-vam-fz0"},_vm._l((_vm.firstTabList),function(item,index){return _c('li',{class:{active:index==_vm.firstTabChoosed},on:{"click":function($event){return _vm.firstTabFn(index)}}},[_c('p',[_vm._v(_vm._s(item.text))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1b74a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu001.vue
// module id = null
// module chunks = 